import {
  ShippingDayDto,
  ShippingDayModel,
  ShippingOpenHoursDto,
  ShippingOpenHoursModel,
} from '../types/shipping-point'

export const transformShippingOpenHoursDto = ({
  opens_at,
  closes_at,
}: ShippingOpenHoursDto): ShippingOpenHoursModel => ({
  opensAt: opens_at,
  closesAt: closes_at,
})

export const transformShippingBusinessHoursDto = ({
  weekday,
  label,
  hours,
}: ShippingDayDto): ShippingDayModel => ({
  weekday,
  label,
  hours: hours?.map(transformShippingOpenHoursDto),
})
